import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {TaskModel} from "../../models/task.model";

@Injectable({providedIn: 'root'})
export class TasksChannelService extends EntitiesChannel<TaskModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "tasks_changed";
  }

  getPartialChannelName(): String {
    return "tasks_partial_changed";
  }

  getCreateChannelName(): String {
    return "";
  }

}
